"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var overflow_menu_1 = __importDefault(require("@paprika/overflow-menu"));
var useI18n_1 = __importDefault(require("@paprika/l10n/lib/useI18n"));
var OverflowMenuTrigger_1 = __importDefault(require("../OverflowMenuTrigger/OverflowMenuTrigger"));
var constants_1 = require("../../constants");
var GlobalNavigation_styles_1 = require("../../GlobalNavigation.styles");
var sc = __importStar(require("./User.styles"));
function User(_a) {
    var customerName = _a.customerName, username = _a.username, userProfileUrl = _a.userProfileUrl, logoutUrl = _a.logoutUrl, zIndex = _a.zIndex;
    var _b = react_1.default.useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var i18n = useI18n_1.default();
    var tooltipLabel = i18n.t('global_navigation.navigation_items.user_with_customer', {
        username: username,
        customerName: customerName,
    });
    function toggleIsOpen() {
        setIsOpen(function (prevIsOpen) { return !prevIsOpen; });
    }
    function handleCloseOverflowMenu() {
        setIsOpen(false);
    }
    function handleClickLogout() {
        window.location.href = logoutUrl;
    }
    return (react_1.default.createElement(sc.UserWrapper, { "data-sri-anchor": "navigation-user" },
        react_1.default.createElement(overflow_menu_1.default, { onClose: handleCloseOverflowMenu, zIndex: zIndex },
            react_1.default.createElement(overflow_menu_1.default.Content, { id: "global-navigation-user__overflow-content", className: "sriracha" }),
            react_1.default.createElement(overflow_menu_1.default.Trigger, { "data-sri-anchor": "navigation-item.trigger", a11yText: tooltipLabel, menuRefId: "global-navigation-user__overflow-content" },
                react_1.default.createElement(OverflowMenuTrigger_1.default, { ariaLabel: tooltipLabel, icon: constants_1.icons.user, isOpen: isOpen, onClick: toggleIsOpen })),
            react_1.default.createElement(sc.OverflowHeader, { "data-sri-anchor": "global-navigation.user-overflow.header" },
                username,
                react_1.default.createElement("br", null),
                react_1.default.createElement(sc.CustomerName, { "data-sri-anchor": "customer-name" }, customerName)),
            react_1.default.createElement(GlobalNavigation_styles_1.OverflowMenuLinkItem, { "data-sri-anchor": "navigation-overflow.link", link: userProfileUrl }, i18n.t('global_navigation.user.my_profile')),
            react_1.default.createElement(GlobalNavigation_styles_1.OverflowMenuItem, { "data-sri-anchor": "navigation-overflow.link", onClick: handleClickLogout }, i18n.t('global_navigation.user.log_out')))));
}
User.propTypes = {
    customerName: prop_types_1.default.string,
    username: prop_types_1.default.string.isRequired,
    userProfileUrl: prop_types_1.default.string.isRequired,
    logoutUrl: prop_types_1.default.string.isRequired,
    zIndex: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
};
User.defaultProps = {
    customerName: null,
    zIndex: null,
};
User.componentType = constants_1.navigationItems.user;
exports.default = User;
//# sourceMappingURL=User.js.map